// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/global.styl
// module id = ./modules/issFrontend/styles/global.styl
// module chunks = 1